/**
 * SEO for the reset-password route (`/auth/reset-password`).
 */

import { env } from '@web/src/lib/env.client'
import { robotsMetaForEnvironment, seo } from '@web/src/lib/seo'
import { absoluteUrlForPath } from '@web/src/lib/utilsClient'

export type ResetPasswordPageSeoLoaderInput = Record<string, never>

export function resetPasswordPageHeadFromLoaderData(_loaderData?: ResetPasswordPageSeoLoaderInput | null | undefined) {
  const pageUrl = absoluteUrlForPath('/auth/reset-password')
  const description =
    'Set a new Spicy Friends password from your email link. Confirm twice, then sign in to protect your messages, events, and profile information.'

  return seo({
    title: `Set a new password | ${env.VITE_APP_NAME}`,
    description,
    url: pageUrl,
    robots: robotsMetaForEnvironment({
      production: 'index, follow',
      staging: 'noindex,nofollow',
    }),
  })
}
